import { createSelector } from 'reselect'
export const getConfig = (state: Record<string, any>) => state.config || {}
export const getNextApp = createSelector(
  [getConfig],
  (config: Record<string, any>): string => config.nextApp || ''
)